import { Suspense, useEffect, useState } from 'react';
import { NarrativeMiniValuatorScreen } from './utils';
import { NarrativeMiniValuatorCompanySelect } from './components/NarrativeMiniValuatorCompanySelectScreen';
import { NarrativeMiniValuatorValuationScreen } from './components/NarrativeMiniValuatorValuationScreen';
import { ErrorBoundary } from '@sentry/react';
import { Alert, AlertAction } from '@simplywallst/ui-core';
import { NarrativeMiniValuatorValuationSkeleton } from './components/NarrativeMiniValuatorValuationSkeleton';

type Props = {
  companyCanonicalUrl?: string | null;
};

export const NarrativeMiniValuator = ({ companyCanonicalUrl }: Props) => {
  const [screen, setScreen] =
    useState<NarrativeMiniValuatorScreen>('valuation');
  const [canonicalUrl, setCanonicalUrl] = useState<string | null>(
    companyCanonicalUrl ?? null
  );

  useEffect(() => {
    if (companyCanonicalUrl) {
      setCanonicalUrl(companyCanonicalUrl);
    }
  }, [companyCanonicalUrl]);

  const renderScreen = () => {
    if (!canonicalUrl || screen === 'companySelect')
      return (
        <NarrativeMiniValuatorCompanySelect
          onCompanySelect={(canonicalUrl) => {
            setScreen('valuation');
            setCanonicalUrl(canonicalUrl);
          }}
        />
      );

    return (
      <NarrativeMiniValuatorValuationScreen
        canonicalUrl={canonicalUrl}
        setScreen={setScreen}
      />
    );
  };
  return (
    <div className="bg-surface-1 text-solid md:rounded-x1_5">
      <ErrorBoundary
        fallback={({ resetError }) => (
          <Alert
            styleType="negative"
            actions={
              <AlertAction
                onClick={() => {
                  setScreen('companySelect');
                  resetError();
                }}
              >
                Select
              </AlertAction>
            }
          >
            Failed to load valuator for this company. Please select another one.
          </Alert>
        )}
      >
        <Suspense fallback={<NarrativeMiniValuatorValuationSkeleton />}>
          {renderScreen()}
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};
